import * as Plot from '@observablehq/plot';
import { fiveNumberSummary } from '../statistics';
import { formatNumber } from '@learnforge/demo-math/numeric';

/** Horizontal box plot with the five-number-summary values annotated above it. */
export function plotBoxLabeled(nums: number[]): HTMLElement {
  const s = fiveNumberSummary(nums);
  const fmt = (d: number) => formatNumber(d, { decimals: 1, trimIntegers: true });
  return Plot.plot({
    marks: [
      Plot.frame({ anchor: 'bottom' }),
      Plot.boxX(nums, { y: () => '' }),
      Plot.text([s.min, s.q1, s.median, s.q3, s.max], {
        x: (d: number) => d,
        y: () => '',
        dy: -48,
        text: fmt,
      }),
    ],
    marginTop: 56,
    marginBottom: 30,
    height: 150,
  }) as HTMLElement;
}
